const safeLocalStorage = () => {
    try {
        return window.localStorage ?? null;
    }
    catch {
        return null;
    }
};
export const setTokens = (accessToken, refreshToken, expirationDate) => {
    const storage = safeLocalStorage();
    if (!storage)
        return;
    if (accessToken) {
        storage.setItem('access_token', accessToken);
    }
    if (refreshToken) {
        storage.setItem('refresh_token', refreshToken);
    }
    if (expirationDate) {
        storage.setItem('expiration_date', expirationDate);
    }
};
export const removeTokens = () => {
    const storage = safeLocalStorage();
    if (!storage)
        return;
    storage.removeItem('access_token');
    storage.removeItem('refresh_token');
};
export const getItems = (items) => {
    const storage = safeLocalStorage();
    return items.map((item) => {
        const result = storage ? storage.getItem(item) : null;
        return [item, result];
    });
};
export const setClientId = (clientId) => {
    const storage = safeLocalStorage();
    if (!storage)
        return;
    storage.setItem('client_id', clientId);
};
export const getClientId = () => {
    const storage = safeLocalStorage();
    return storage ? storage.getItem('client_id') : null;
};
